import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../../initializers/polyfill_closest';

import 'jquery-ujs';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-validation/dist/localization/messages_ja';

import '../../initializers/validates';
import '../../initializers/exists';
import '../../initializers/prevent_enter_submit';
import '../../initializers/bugsnag';
import '../../initializers/sentry';

import 'bootstrap';
import 'moment/locale/ja';
import 'eonasdan-bootstrap-datetimepicker';
import 'cropper';

import '../../vendor/jquery.iframe-transport';
import '../../vendor/jquery.remotipart';

import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '../../admin/stylesheets/bootstrap.scss';
import '../../admin/stylesheets/application.scss';

const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(require.context('../../admin/src', true, /.js$/));

const application = Application.start();
const context = require.context('../../admin/controllers', true, /.js$/);
application.load(definitionsFromContext(context));
